/**
 * Cross-subdomain sign-in hint.
 *
 * The auth token itself lives in localStorage on the app origin, which this
 * marketing site cannot read — localStorage is origin-scoped, so www.flass.io
 * has no visibility of chat.flass.io. Instead the app writes a small flag
 * cookie on the shared parent domain when someone signs in and clears it when
 * they sign out. The cookie carries no credential; it only answers "is there a
 * session over there?" so a returning user can be sent straight to the app.
 */

const APP_URL = 'https://chat.flass.io';
const SESSION_COOKIE = 'flass_session';

/** Lets a signed-in user read the marketing pages: append ?stay=1. */
const STAY_PARAM = 'stay';

const hasSession = () => {
	if (typeof document === 'undefined') return false;
	return document.cookie
		.split(';')
		.some((c) => c.trim().startsWith(`${SESSION_COOKIE}=1`));
};

const wantsToStay = () => {
	if (typeof window === 'undefined') return false;
	return new URLSearchParams(window.location.search).has(STAY_PARAM);
};

/**
 * Sends a signed-in visitor to the app. Returns true when a redirect started,
 * so callers can skip rendering a page that is about to be replaced.
 */
const redirectToAppIfSignedIn = () => {
	if (!hasSession() || wantsToStay()) return false;
	// replace(), not assign(), so Back does not bounce between the two sites.
	window.location.replace(APP_URL);
	return true;
};

export { APP_URL, SESSION_COOKIE, hasSession, redirectToAppIfSignedIn };
